// hooks/useUnsavedChangesWarning.ts
import { useCallback, useEffect, useState } from "react";
import { useBlocker } from "react-router-dom";

const deepCompare = (a: any, b: any) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const useUnsavedChangesWarning = (
  currentValues: any,
  defaultValues: any
) => {
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    const hasChanged = !deepCompare(defaultValues, currentValues);
    setIsDirty(hasChanged);
  }, [currentValues]);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname
  );

  const isBlocked = blocker.state === "blocked";

  const handleProceed = useCallback(() => {
    if (blocker.proceed) blocker.proceed();
  }, [blocker]);

  const handleCancel = useCallback(() => {
    if (blocker.reset) blocker.reset();
  }, [blocker]);

  return {
    blocker,
    handleProceed,
    handleCancel,
    isDirty,
    isBlocked,
  };
};
